import React from "react";

const AvatarPlaceholder: React.FC = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="50" fill="#F5F5F5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.7499 38.75C38.7499 32.5368 43.7867 27.5 49.9999 27.5C56.2131 27.5 61.2499 32.5368 61.2499 38.75C61.2499 44.9632 56.2131 50 49.9999 50C43.7867 50 38.7499 44.9632 38.7499 38.75ZM40.1361 55.9532C41.8323 55.582 43.5519 55.334 45.2532 55.2134C48.4114 54.9289 51.5879 54.9289 54.7462 55.2134L55.7546 55.3005C57.1339 55.4393 58.5034 55.6567 59.8511 55.9506C63.2862 56.6732 65.7806 57.9551 66.8848 60.3329C67.7051 62.102 67.7051 64.1557 66.8844 65.9256C65.7775 68.3094 63.2509 69.6021 59.8767 70.2818L58.8544 70.4985C57.488 70.7663 56.1101 70.9491 54.7414 71.0447C52.1731 71.268 49.5927 71.3087 47.1037 71.1689C46.8293 71.1689 46.6452 71.1679 46.4829 71.1641L46.1674 71.152C45.7837 71.132 45.4322 71.091 45.2847 71.0468C43.553 70.9267 41.8329 70.6707 40.1827 70.2905L39.623 70.1712C36.4983 69.4622 34.1842 68.1832 33.1138 65.923C32.7084 65.046 32.4987 64.0874 32.5 63.1251C32.4964 62.1558 32.7078 61.1983 33.1283 60.3042C34.2431 58.0177 36.8622 56.6418 40.1361 55.9532Z"
        fill="#EAEAEA"
      />
    </svg>
  );
};

export default AvatarPlaceholder;
